<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="企微裂变"
      >
        <div class="slot">
          <img class="bg" :src="gameBgp" v-if="gameBgp" />
          <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShow">
              更换活动海报
            </div>
          </div>
        </div>
        <!-- <div class="slot">
          <img class="bg" :src="gameBgp2" v-if="gameBgp2" />
          <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShowgameBgp2">
              更换背景图
            </div>
          </div>
          <img
            :src="gameBgp3"
            style="
              width: 100px;
              height: 100px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              margin-top: -50px;
            "
            v-if="gameBgp3"
          />
          <div
            class="upload-img bg3"
            @click="toggleShowgameBgp3"
            style="margin-top: -50px"
          >
            <span class="hmicon icon-shangchuantupian1"></span>
          </div>
          <img
            :src="gameBgp4"
            style="
              width: 100px;
              height: 100px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              margin-top: 50px;
            "
            v-if="gameBgp4"
          />
          <div
            class="upload-img bg4"
            @click="toggleShowgameBgp4"
            style="margin-top: 50px"
          >
            <span class="hmicon icon-shangchuantupian1"></span>
          </div>
        </div> -->
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-wrap">
            <div class="flex-4">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="170px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                    maxlength="25"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameName"
                    placeholder="请输入活动标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动时间" prop="activityDate">
                  <el-date-picker
                    :default-time="['00:00:00', '23:59:59']"
                    v-model="ruleForm.activityDate"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    align="right"
                    start-placeholder="活动开始时间"
                    end-placeholder="活动结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="活动规则" prop="gameRuleRemark">
                  <hm-rich-editor
                    v-model="ruleForm.gameRuleRemark"
                    :html="ruleForm.gameRuleRemark"
                  />
                </el-form-item>
                <el-form-item label="活动背景" prop="gameBgp">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp"
                    v-if="showgameBgp"
                    noCircle
                    noSquare
                    :width="750"
                    :height="1334"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShow"
                      v-if="!gameBgp"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传活动背景</span>
                    </div>
                    <div v-if="gameBgp" class="priview mr10 flex item-end">
                      <img :src="gameBgp" alt="活动背景" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShow"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip"
                        >建议尺寸：750x1334像素，支持jpg/jpeg/png格式</span
                      >
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动客服" prop="kfSwitch">
                  <el-switch
                    v-model="ruleForm.storeGameFission.kfSwitch"
                    active-text="开启"
                    inactive-text="关闭"
                    active-color="#13ce66"
                    active-value="1"
                    inactive-value="0"
                  >
                  </el-switch>
                  <div class="form-tip">
                    客户参与活动遇到问题，可联系客服咨询
                  </div>
                  <div v-if="ruleForm.storeGameFission.kfSwitch === '1'">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp2"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp2"
                    v-if="showgameBgp2"
                    noCircle
                    noSquare
                    :width="300"
                    :height="300"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>

                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp2"
                      v-if="!gameBgp2"
                    >
                      <div class="add-wrapper flex flex-center">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传图片</span>
                    </div>
                    <div v-if="gameBgp2" class="priviewbgp2 mr10 flex item-end">
                      <img :src="gameBgp2" alt="图片" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp2"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">上传联系客服二维码图片</span>
                    </div>
                  </div>
                  </div>
                </el-form-item>

                <el-form-item label="企业名称" prop="companyName" v-if="gameType === 'fission_person'">
                  <el-input
                    maxlength="25"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.storeGameFission.companyName"
                    placeholder="请输入企业名称"
                  ></el-input>
                </el-form-item>

                <el-form-item label="企业logo" prop="companyLogo" v-if="gameType === 'fission_person'">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp5"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp5"
                    v-if="showgameBgp5"
                    noCircle
                    noSquare
                    :width="200"
                    :height="200"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>

                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp5"
                      v-if="!gameBgp5"
                    >
                      <div class="add-wrapper flex flex-center">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传图片</span>
                    </div>
                    <div v-if="gameBgp5" class="priviewbgp5 mr10 flex item-end">
                      <img :src="gameBgp5" alt="图片" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp5"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">1、支持上传jpg/jpeg/png格式图片</span><br />
                      <span class="form-tip">2、大小不超过2M</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="自动通过" prop="autoPass" v-if="gameType === 'fission_person'">
                  <el-switch
                    v-model="ruleForm.storeGameFission.autoPass"
                    active-text="开启"
                    inactive-text="关闭"
                    active-color="#13ce66"
                    active-value="1"
                    inactive-value="0"
                  >
                  </el-switch>
                  <div>
                    <span class="form-tip">新客添加时无需经过确认自动成为好友</span>
                  </div>
                </el-form-item>  

                <el-form-item label="新用户欢迎语" prop="newWelcomeContent" v-if="gameType === 'fission_person'">
                  <el-input
                    style="width: 400px"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 7 }"
                    placeholder="请输入新用户欢迎语"
                    v-model.trim="ruleForm.storeGameFission.newWelcomeContent"
                  >
                  </el-input>
                  <div class="form-tip form-tip-bg">
                    1.建议将活动的邀请和奖励规则写在邀请文案中，被邀请者添加员工时即可第一时间通过欢迎语了解到活动规则，同时可避免微信因“利诱分享 原因而封禁活动<br>
                    2.若企业成员在好友欢迎语和企微裂变中均被设置了欢迎语，那么当用户通过企微烈变活动添加其为好友时，将会收到个微烈变中设置的欢迎语
                  </div>
                </el-form-item>

                <el-form-item label="入群欢迎语" prop="gameWelcomeContent" v-if="gameType === 'fission_group'">
                  <el-input
                    style="width: 400px"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 7 }"
                    placeholder="请输入入群欢迎语"
                    v-model.trim="ruleForm.storeGameFission.newWelcomeContent"
                  >
                  </el-input>
                  <div class="form-tip form-tip-bg">
                    1.设置入群欢迎语素材目的是为了邀请客户参与活动，是整个裂变活动中重要的步骤<br />
                    2.活动创建成功后，欢迎语链接将自动填入裂变活动链接<br />
                    3.群欢迎语素材设置完成后，请提示对应的群主前往移动端活动群聊设置入群欢迎语，客户进群才会收到参与活动链接哦~
                  </div>
                </el-form-item>

                <el-form-item label="新用户邀请裂变小程序封面" prop="gameBgp3">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp3"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp3"
                    noCircle
                    noSquare
                    :width="500"
                    :height="400"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp3"
                      v-if="!gameBgp3"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传封面图</span>
                    </div>
                    <div v-if="gameBgp3" class="priviewbgp3 mr10 flex item-end">
                      <img :src="gameBgp3" alt="封面图" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp3"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">1、支持上传jpg/jpeg/png格式图片</span><br />
                      <span class="form-tip"
                        >2、大小不超过2M</span
                      >
                    </div>
                  </div>
                  <div class="form-tip form-tip-bg">
                    <div class="red">为了防止活动因违规被封造成损失，禁止出现如邀请、助力、推荐、免费、福利、赠送等利诱分享相关词语，更多违规内容见</div>
                    <div class="blue">《微信外部链接内容管理规范》</div>
                  </div>
                </el-form-item>

                <div class="mt40" id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}裂变海报设置
                </div>

                <el-form-item label="推荐文案" prop="posterTitle">
                  <el-input
                    maxlength="30"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.storeGameFission.posterTitle"
                    placeholder="请输入推荐文案"
                  ></el-input>
                  <div class="form-tip">
                    设置海报分享话术，客户分享裂变海报时可以直接粘贴文案发送给好友。
                  </div>
                </el-form-item>

                <el-form-item label="裂变海报" prop="gameBgp4">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp4"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp4"
                    noCircle
                    noSquare
                    :width="750"
                    :height="1100"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp4"
                      v-if="!gameBgp4"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传裂变海报</span>
                    </div>
                    <div v-if="gameBgp4" class="priviewbgp4 mr10 flex item-end">
                      <img :src="gameBgp4" alt="裂变海报" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp4"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">1、建议尺寸:750px*1100px</span><br />
                      <span class="form-tip"
                        >2、支持上侍jpg/jpeg/png格式图片，大小不超过2M</span
                      >
                    </div>
                  </div>
                  <div class="form-tip form-tip-bg">
                    <div class="red">为了防止活动因违规被封造成损失，禁止出现如邀请、助力、推荐、免费、福利、赠送等利诱分享相关词语，更多违规内容见</div>
                    <div class="blue">《微信外部链接内容管理规范》</div>
                  </div>
                </el-form-item>

                <div class="mt40" id="gameLimit">
                  {{ steps.length === 3 ? 3 : 3 }}奖品信息
                </div>

                <el-form-item label="奖品信息" prop="drawTypeList">
                  <div
                    class="form-tips"
                    style="color: #e50163; font-size: 12px"
                  >
                    <!-- 活动奖品设置文字 -->
                  </div>
                  <el-table
                    :data="ruleForm.storeGameFission.turntablePrizeRuleList"
                    style="width: 100%"
                    ref="table"
                    border
                    stripe
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品名称"
                      prop="prizeName"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="60"
                            style="width: 100%"
                            v-model.trim="scope.row.prizeName"
                            placeholder="奖品名称"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品图片"
                      prop="prizeImg"
                    >
                      <template slot-scope="scope">
                        <div class="flex flex-center">
                          <div
                            class="flex goods-upload-btn"
                            @click="addGoodsImg(scope.row, 'prizeImg')"
                            v-if="!scope.row.prizeImg"
                          >
                            <div
                              style="margin-left: 0px"
                              class="btn flex flex-column flex-center open-file item-center"
                            >
                              <div class="add-prize-img-wrapper">
                                <span class="hmicon icon-hao pointer"></span>
                              </div>
                              <span>添加图片</span>
                            </div>
                          </div>
                          <div v-else class="mr10 flex item-end priviews">
                            <el-image
                              class="img"
                              :src="scope.row.prizeImg"
                              alt="logo"
                              :preview-src-list="[scope.row.prizeImg]"
                            />
                            <div
                              class="opreat-wrapper flex item-center flex-center"
                            >
                              <el-button
                                type="text"
                                @click="handleRemove(scope.$index)"
                                >删除</el-button
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品数量"
                      prop="prizeNum"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="60"
                            style="width: 100%"
                            @input="
                              filterGt0OrFixed0(scope.$index, 'prizeNum')
                            "
                            v-model.trim="scope.row.prizeNum"
                            placeholder="请输入数量"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="获奖邀请人数条件"
                      prop="awardThreshold"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="60"
                            style="width: 100%"
                            @input="
                              filterGt0OrFixed0(scope.$index, 'awardThreshold')
                            "
                            v-model.trim="scope.row.awardThreshold"
                            placeholder="请输入数字"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
                <div class="flex flex-center">
                  <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('ruleForm')"
                    v-if="type!=='details'"
                    >发布
                  </el-button>
                  <el-button size="small" @click="$router.back(-1)"
                    >返回
                  </el-button>
                </div>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccessMy"
          @crop-upload-fail="cropUploadFail"
          v-model="showPrizeImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'goodsCenter' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
      </div>
    </div>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { arrayUnique2 } from "@/utils/utils";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";

import XLSX from "xlsx";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMSGoods,
    actPreview,
  },
  data() {
    const actDate = function (rule, val, callback) {
      if (!this.ruleForm.activityDate.length > 0) {
        return callback(new Error("请选择活动时间段"));
      }
      callback();
    }.bind(this);
    const patterndgameBgpFunc = function (rule, val, callback) {
      if (!this.gameBgp) {
        return callback(new Error("请上传活动背景"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp2Func = function (rule, val, callback) {
      if (!this.gameBgp2) {
        return callback(new Error("请上传客服二维码"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp3Func = function (rule, val, callback) {
      if (!this.gameBgp3) {
        return callback(new Error("请上传小程序封面"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp4Func = function (rule, val, callback) {
      if (!this.gameBgp4) {
        return callback(new Error("请上传海报页面"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp5Func = function (rule, val, callback) {
      if (!this.gameBgp5) {
        return callback(new Error("请上传公司logo"));
      }
      callback();
    }.bind(this);
    return {
      type: "",
      gameType: "",
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        },
      },
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      gameBgp: 
      "https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img03.png",
      gameBgp2: "",
      // "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img04.png",
      gameBgp3: "",
      // "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img24.png",
      gameBgp4: "https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img05.png",
      // "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img25.png",
      gameBgp5: "",
      showgameBgp: false,
      showgameBgp2: false,
      showgameBgp3: false,
      showgameBgp4: false,
      showgameBgp5: false,
      showPrizeImg: false,
      dialogVisible: false,
      currentGoods: {},
      steps: [
        {
          id: "base",
          name: "基本信息",
        },
        {
          id: "gameRule",
          name: "活动规则",
        },
        {
          id: "gameLimit",
          name: "活动限制",
        },
      ],
      ruleForm: {
        gameType: "",
        gameName: "",
        activityDate: [],
        gameStartTime: "",
        gameEndTime: "",
        gameBgp: "",
        gameRuleRemark: "",
        storeGameFission:[

        ],
        storeGameFission:{
          autoPass: "1",
          kfSwitch: "1",
          serverQrCode: "",
          newWelcomeContent: "",
          xcMainLogo: "",
          posterTitle: "",
          posterPhotoUrl: "",
          turntablePrizeRuleList:[
            {
              prizeType: "3",
              typeValue: "实物",
              prizeName: "",
              prizeImg: "",
              prizeNum: "",
              awardThreshold: "",
              winningRate: 1,
            }
          ]
        },
      },
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        gameBgp: [
          {
            required: true,
            validator: patterndgameBgpFunc,
            trigger: "blur",
          },
        ],
        gameBgp2: [
          {
            required: true,
            validator: patterndgameBgp2Func,
            trigger: "blur",
          },
        ],
        gameBgp3: [
          {
            required: true,
            validator: patterndgameBgp3Func,
            trigger: "blur",
          },
        ],
        gameBgp4: [
          {
            required: true,
            validator: patterndgameBgp4Func,
            trigger: "blur",
          },
        ],
        gameBgp5: [
          {
            required: true,
            validator: patterndgameBgp5Func,
            trigger: "blur",
          },
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur",
          },
        ],
        activityDate: {
          required: true,
          validator: actDate,
          trigger: "blur",
        },
      },
      options: [
        {
          value: "1",
          label: "1",
        },
      ],
      CouponRules: [], //券规则
      actDesc: {},
      sole: Boolean,
      isCollapse: true,
      total: 0,
      couponList: [],
      currentPage: 1,
      pageSize: 10,
      selectedCoupons: [],
      currentRow: {},
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "virtualGoods"]),
  watch: {
  },
  created() {
    this.gameType = this.$route.query.gameType;
    this.type = this.$route.query.type;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.queryCouponList();
    this.calcHeight();
    this.$store.dispatch("queryStoreStyle");
    if (this.$route.query.gameId) {
      this.activityDetail().then((res) => {
        console.log("res:", res.result);
        let result = res.result;
        this.ruleForm = result;
        this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
        this.ruleForm.gameType = result.gameType;
        this.gameBgp = result.gameBgp;
        if(this.ruleForm.gameType === 'fission_group'){
          this.ruleForm.storeGameFission = this.ruleForm.storeGameFissionGroupModel;
        }
        if(this.ruleForm.gameType === 'fission_person'){
          this.ruleForm.storeGameFission = this.ruleForm.storeGameFissionPersonModel;
          this.gameBgp5 = this.ruleForm.storeGameFission.companyLogo;
        }
        this.gameBgp2 = this.ruleForm.storeGameFission.serverQrCode;
        this.gameBgp3 = this.ruleForm.storeGameFission.xcMainLogo;
        this.gameBgp4 = this.ruleForm.storeGameFission.posterPhotoUrl;
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
      });
    }
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    filterGt0OrFixed22(index, prop) {
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
        ); //限制只能输入两个小数
      if (
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].indexOf(".") < 0 &&
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] = parseFloat(
          this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop]
        );
      }
    },
    filterGt0OrFixed0(index, prop) {
      // this.ruleForm.storeGameFission.turntablePrizeRuleList[index][
      //   prop
      // ] = this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop].replace(/[^\d]/g, "");
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] =
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop]
          .replace(".", "")
          .replace("-", "")
          .replace(",", "");
      // console.log(this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop]);
      this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop] = new Number(
        this.ruleForm.storeGameFission.turntablePrizeRuleList[index][prop]
      );
    },
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId,
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    filterGt0OrFixed(prop, i) {
      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop] =
        this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop] =
        this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop]
          .replace(".", "")
          .replace("-", "");

      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop] =
        this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop].replace(
          /\.{2,}/g,
          ""
        ); //两个连续的"."仅保留第一个"."
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccessMy(jsonData) {
      if (this.uploadType === "prizeImg") {
        this.currentGoods.prizeImg = jsonData.result;
        console.log("this.currentGoods: ", this.currentGoods);
        return;
      }
    },
    cropUploadSuccess(jsonData) {
      if (this.showgameBgp) {
        this.gameBgp = jsonData.result;
      }
    },
    cropUploadSuccessBgp2(jsonData) {
      if (this.showgameBgp2) {
        this.gameBgp2 = jsonData.result;
      }
    },
    cropUploadSuccessBgp3(jsonData) {
      if (this.showgameBgp3) {
        this.gameBgp3 = jsonData.result;
      }
    },
    cropUploadSuccessBgp4(jsonData) {
      if (this.showgameBgp4) {
        this.gameBgp4 = jsonData.result;
      }
    },
    cropUploadSuccessBgp5(jsonData) {
      if (this.showgameBgp5) {
        this.gameBgp5 = jsonData.result;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.showgameBgp = !this.showgameBgp;
    },
    toggleShowgameBgp2() {
      this.showgameBgp2 = !this.showgameBgp2;
    },
    toggleShowgameBgp3() {
      this.showgameBgp3 = !this.showgameBgp3;
    },
    toggleShowgameBgp4() {
      this.showgameBgp4 = !this.showgameBgp4;
    },
    toggleShowgameBgp5() {
      this.showgameBgp5 = !this.showgameBgp5;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1 <= 0 ? 1 : i - 1;
          }
        }
      });
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      this.showPrizeImg = true;
      this.currentGoods = v;
    },
    submitForm(formName) {
      let params;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          this.ruleForm.gameBgp = this.gameBgp;
          this.ruleForm.gameType = this.gameType;
          this.ruleForm.storeGameFission.serverQrCode = this.gameBgp2;
          this.ruleForm.storeGameFission.xcMainLogo = this.gameBgp3;
          this.ruleForm.storeGameFission.posterPhotoUrl = this.gameBgp4;
          this.ruleForm.storeGameFission.companyLogo = this.gameBgp5;
          if(this.gameType === 'fission_group'){
            this.ruleForm.storeGameFissionGroupModel = this.ruleForm.storeGameFission;
          }
          if(this.gameType === 'fission_person'){
            this.ruleForm.storeGameFissionPersonModel = this.ruleForm.storeGameFission;
          }
          console.log("this.ruleForm", this.ruleForm);
          this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
          params = this.ruleForm;
          console.log("params", params);

          // return;
          let url = 'saveGameInfo';
          if(this.type === 'edit'){
            url = 'editActivity'
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove(index) {
      this.$set(
        this.ruleForm.redEnvelopeRainPrizeRuleModels[index],
        "prizeImg",
        ""
      );
    },
    //查询优惠券
    queryCouponList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store.dispatch("findCouponSendByEvent", params).then((res) => {
        if (res.code === "0") {
          this.couponList = res.result;
        }
      });
    },
    deleteAppend(index) {
      this.ruleForm.redEnvelopeRainPrizeRuleModels.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.add-goods-containers {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .btn {
    margin-left: 10px;

    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;

    .commodityImg {
      width: 150px;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .actcontent {
      width: 161px;
      height: 100px;
      margin-left: 20px;

      .activityTitle {
        font-size: 18px;
        font-weight: 600;
        margin-top: -1px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }

      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }

      .originalCost {
        color: #919191;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }

    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }

    .describe {
      width: 100%;
      color: #ffffff;
      font-size: 17px;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 248px;
    }
  }

  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
  }
}

.table {
  border: 1px solid #ddd;

  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }

  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }

  .table-row:nth-child(even) {
    background: #f7f7f7;
  }

  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.priview {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }

  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;

  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
}

.font-ms {
  font-size: 14px;
  color: #666666;
}

.priviewbgp2 {
  position: relative;
  width: 375px;
  height: 375px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp3{
  position: relative;
  width: 250px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp4 {
  position: relative;
  width: 300px;
  height: 400px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp5 {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.slot {
  position: relative;
  width: 375px;
  height: 667px;
  .bg {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .change-bg {
      display: block;
    }
  }
  .change-bg {
    position: absolute;
    top: 60px;
    right: 0;
    height: 34px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.8);
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    z-index: 10;
    padding: 0 10px;
    display: none;
  }
  &:hover {
    .upload-img {
      display: block;
    }
  }
  .bg3,
  .bg4 {
    position: absolute;
    cursor: pointer;
    display: none;
    top: 50%;
    left: 50%;
    margin-left: -17px;
    margin-top: -17px;
    z-index: 9030;
    zoom: 1;
    width: 34px;
    height: 34px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.8);
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    .hmicon {
      color: #fff;
    }
  }
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 100px;
    height: 100px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin: 0;
      }
    }
  }
}
.form-tip-bg {
  background: #f2f5f8;
  padding: 20px;
  line-height: 30px;
  margin-top: 20px;
  border-radius: 10px;
  .red{
    color: #FF0000;
  }
  .blue{
    color: #3180FF;
  }
}
</style>
